export default "__VITE_ASSET__00t5i_pn__"